/* ============================================================================
FILE: po-axis-posoennomia-texts-fr-en-es-20260202.js
MODE: TwinLang FR/EN/ES via localStorage + lexicon injection
API:  window.PoAxisPosoennomiaTextsFR_EN_ES_20260202
ROOT: .po-axis-section[data-po-axis]

ROLE:
  - Langue pilotée par localStorage : po_lex_lang + goody_gp_lang.
  - Expose getLang(), setLang(lang), init() et déclenche po:locale-changed.
  - Ré-injecte le contenu trilingue (fallback + lexique si dispo) dans les slots.
  - Protège finement les occurrences du lexique canonique FR dans le DOM rendu.
  - Conserve l’inversion demandée des 2 URL Univers / Idéogramme dans les CHIPS,
    sans toucher à l’image au-dessus du titre (slot title_img).
  - Ajoute une couche audio générale + locale par bloc, sans remplacer la logique
    de langue, de lexique ni les protections translate="no" / .notranslate.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_AXIS_POSOENNOMIA_TEXTS_20260202__) return;
  window.__PO_AXIS_POSOENNOMIA_TEXTS_20260202__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis]";

  var CANON = {
    title: "Posœnnomia"
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    var p = (s.split("-")[0] || "");
    if (p === "fr") return "fr";
    if (p === "es" || p === "pt") return "es";
    if (p === "en") return "en";
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function detectRawLang(){
    if (typeof window !== "undefined" && window.PO_SITE_LANG) return window.PO_SITE_LANG;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return dl;
    var nav = (typeof navigator !== "undefined") ? navigator : null;
    if (nav && nav.languages && nav.languages.length) return nav.languages[0] || "";
    if (nav && nav.language) return nav.language || "";
    return "fr";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getBrowserLang(){
    return normLang(detectRawLang());
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    return getBrowserLang();
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(_e){}
    return null;
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    try{
      if (entry.defs && entry.defs[lang]) return clampStr(entry.defs[lang]);
    }catch(e){}
    try{
      var k = "definition_" + lang;
      if (entry[k]) return clampStr(entry[k]);
      if (entry.definition_fr) return clampStr(entry.definition_fr);
      if (entry.definition_oper_fr) return clampStr(entry.definition_oper_fr);
    }catch(_e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    try{
      var ku = "usage_" + lang;
      if (entry[ku]) return clampStr(entry[ku]);
    }catch(e){}
    try{
      var kop = "definition_oper_" + lang;
      if (entry[kop]) return clampStr(entry[kop]);
    }catch(_e){}
    try{
      var kd = "definition_" + lang;
      if (entry[kd]) return clampStr(entry[kd]);
      if (entry.usage_fr) return clampStr(entry.usage_fr);
      if (entry.definition_oper_fr) return clampStr(entry.definition_oper_fr);
      if (entry.definition_fr) return clampStr(entry.definition_fr);
    }catch(__e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickArraySmart(entry, lang, bases){
    if (!entry) return [];
    var i, arr, kfr, vfr;
    for (i=0;i<bases.length;i++){
      arr = pickArray(entry, lang, bases[i]);
      if (arr && arr.length) return arr;
    }
    for (i=0;i<bases.length;i++){
      kfr = bases[i] + "_fr";
      try{
        vfr = entry[kfr];
        if (Array.isArray(vfr) && vfr.length) return vfr;
      }catch(e){}
    }
    return [];
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine (occurrence par occurrence)
   * -------------------------------------------------------------------------- */

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "").trim();
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term).trim();
    if (!t) return out;

    function add(v){ uniqPush(out, v, seen); }

    add(t);
    add(t.replace(/’/g, "'"));
    add(t.replace(/'/g, "’"));
    add(t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    add(t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));

    var splitSlash = t.split("/");
    if (splitSlash.length > 1){
      for (var i=0;i<splitSlash.length;i++) add(splitSlash[i].trim());
    }

    return out;
  }

  var __PO_PROTECT_CACHE__ = { key:"", terms:[], re:null };

  function collectSeedTerms(){
    return [
      "Posœnnoïsme","Posœnnoïa","Posœnnoïamie","Posœnnomia","Katûvýsissence",
      "RéZonans","Illusion","Aliœvolution","Péroptissimisme","Sujet pluriel",
      "Superposition de perspectives","Instantané multiple","Addition synchrêtique",
      "Posœnnoïaque","Posœnnoïque","Méditations Posœnnoïales","Accords Posœnnoïaux",
      "Organon posœnnoïal","Ennéagone","Axis","Àpákan"
    ];
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(_e){}
    return [];
  }

  function collectCanonicalTermsFR(){
    var out = [];
    var seen = Object.create(null);
    var i, j, list, entry, terms, variants;

    list = collectSeedTerms();
    for (i=0;i<list.length;i++){
      variants = buildVariants(list[i]);
      for (j=0;j<variants.length;j++) uniqPush(out, variants[j], seen);
    }

    list = getSimplifiedLexiqueFRList();
    for (i=0;i<list.length;i++){
      variants = buildVariants(list[i]);
      for (j=0;j<variants.length;j++) uniqPush(out, variants[j], seen);
    }

    try{
      if (window.PO_LEXICON_MAP){
        for (var id in window.PO_LEXICON_MAP){
          if (!window.PO_LEXICON_MAP.hasOwnProperty(id)) continue;
          entry = window.PO_LEXICON_MAP[id];
          if (!entry || !entry.terms || !entry.terms.fr) continue;
          variants = buildVariants(entry.terms.fr);
          for (j=0;j<variants.length;j++) uniqPush(out, variants[j], seen);
        }
      }else if (Array.isArray(window.PO_LEXICON)){
        for (i=0;i<window.PO_LEXICON.length;i++){
          entry = window.PO_LEXICON[i];
          if (!entry || !entry.terms || !entry.terms.fr) continue;
          variants = buildVariants(entry.terms.fr);
          for (j=0;j<variants.length;j++) uniqPush(out, variants[j], seen);
        }
      }
    }catch(e){}

    out.sort(function(a,b){ return b.length - a.length; });
    return out;
  }

  function buildProtectRegex(terms){
    if (!terms || !terms.length) return null;
    var parts = [];
    for (var i=0;i<terms.length;i++) parts.push(escapeRegExp(terms[i]));
    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }
    catch(e){ return null; }
  }

  function ensureProtectEngineReady(){
    var key = "none";
    try{
      if (window.PO_LEXICON_MAP) key = "map";
      else if (Array.isArray(window.PO_LEXICON)) key = "arr:" + window.PO_LEXICON.length;
    }catch(e){ key = "none"; }

    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;

    var terms = collectCanonicalTermsFR();
    var re = buildProtectRegex(terms);
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.terms = terms;
    __PO_PROTECT_CACHE__.re = re;
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
      if (cls.indexOf("po-lex-locknode") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;
    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);
      last = start + match.length;
      if (!match.length) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;
    var NodeFilterRef = (typeof NodeFilter !== "undefined") ? NodeFilter : (window && window.NodeFilter ? window.NodeFilter : null);
    if (!NodeFilterRef) return String(html);

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilterRef.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilterRef.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilterRef.FILTER_REJECT;
            return NodeFilterRef.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){
      return String(html);
    }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt).trim();
    if (!s) return "";
    var parts = s.split(/\n{2,}/);
    var out = [];
    for (var i=0;i<parts.length;i++){
      out.push("<p>" + escapeHTML(parts[i]).replace(/\n+/g, "<br />") + "</p>");
    }
    return out.join("");
  }

  /* --------------------------------------------------------------------------
   * SLOTS helpers
   * -------------------------------------------------------------------------- */

  function qs(root, sel){
    try{ return root.querySelector(sel); }catch(e){ return null; }
  }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var s = clampStr(src);
    if (!s) return;
    el.setAttribute("src", s);
    if (alt != null) el.setAttribute("alt", clampStr(alt));
  }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectKeywordsHTML(escapeHTML(clampStr(arr[i]))) + "</li>");
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var t = clampStr(exampleTitle);
    var x = clampStr(exampleText);
    if (!t && !x){
      el.innerHTML = "";
      return;
    }
    var html =
      '<div class="po-lex-example__title"><strong>' + escapeHTML(t) + '</strong></div>' +
      '<div class="po-lex-example__text">' + escapeHTML(x).replace(/\n/g, '<br />') + '</div>';
    el.innerHTML = protectKeywordsHTML(html);
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(clampStr(b.head))) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(htmlParagraphize(clampStr(b.text))) + '</div>' +
        '</div>'
      );
    }
    el.innerHTML = out.join("");
  }

  function protectSlotTextIfNeeded(root, slot){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var txt = el.textContent || "";
    if (!txt) return;
    el.innerHTML = protectKeywordsHTML(escapeHTML(txt));
  }

  function lockSlotNode(root, slot){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.setAttribute("translate", "no");
    var cls = (typeof el.className === "string") ? el.className : "";
    if (cls.indexOf("notranslate") === -1) cls = (cls ? cls + " " : "") + "notranslate";
    if (cls.indexOf("po-lex-locknode") === -1) cls = (cls ? cls + " " : "") + "po-lex-locknode";
    el.className = cls;
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles-posoennomia")) return;
    var st = document.createElement("style");
    st.id = "po-axis-audio-styles-posoennomia";
    st.textContent =
      ".po-axis-audio-wrap{display:flex;justify-content:flex-start;align-items:center;margin:10px 0;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(0,0,0,.03);color:inherit;border-radius:999px;padding:8px 12px;font:inherit;font-size:13px;font-weight:700;line-height:1.2;cursor:pointer;transition:background .2s ease,border-color .2s ease,transform .2s ease;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.06);border-color:rgba(0,0,0,.22);transform:translateY(-1px);}" +
      ".po-axis-audio-btn:focus-visible{outline:2px solid rgba(0,0,0,.35);outline-offset:2px;}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;}";
    (document.head || document.documentElement).appendChild(st);
  }

  function getTargetBlocks(){
    var all;
    var out = [];
    try{ all = document.querySelectorAll(ROOT_SEL) || []; }
    catch(e){ return []; }
    for (var i=0;i<all.length;i++){
      if (getAxisLexId(all[i]) === "posoennomia") out.push(all[i]);
    }
    return out;
  }

  function getAudioRoots(){ return getTargetBlocks(); }

  function getDetailBlocks(root){
    return root ? Array.prototype.slice.call(root.querySelectorAll(".po-lex-details") || []) : [];
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var clone = detail.cloneNode(true);
    removeAudioButtonsFromClone(clone);
    var summaryTitle = getTextValue(clone.querySelector(".po-lex-summary__title"));
    var body = clone.querySelector(".po-lex-list, .po-lex-example, .po-lex-family, .po-lex-wordbuild");
    var allBody = getTextValue(clone);
    var text = summaryTitle;
    if (body) text += (text ? ". " : "") + getTextValue(body);
    else if (allBody) text = allBody;
    return clampStr(text).trim();
  }

  function splitIntoSentences(text){
    var t = clampStr(text).replace(/\s+/g, " ").trim();
    if (!t) return [];
    var parts = t.match(/[^.!?…]+[.!?…]?/g) || [t];
    var out = [];
    for (var i=0;i<parts.length;i++){
      var p = clampStr(parts[i]).trim();
      if (p) out.push(p);
    }
    return out;
  }

  function chunkText(text, maxLen){
    var lim = maxLen || 200;
    var sentences = splitIntoSentences(text);
    var chunks = [];
    var cur = "";
    for (var i=0;i<sentences.length;i++){
      var s = sentences[i];
      if (!cur){ cur = s; continue; }
      if ((cur + " " + s).length <= lim){
        cur += " " + s;
      }else{
        chunks.push(cur);
        cur = s;
      }
    }
    if (cur) chunks.push(cur);
    if (!chunks.length && text) chunks.push(clampStr(text));
    return chunks;
  }

  function pickVoiceForLang(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== "function") return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    var want = normLang(lang);
    var i, v, lc;
    for (i=0;i<voices.length;i++){
      v = voices[i];
      lc = clampStr(v && v.lang).toLowerCase();
      if (want === "fr" && lc.indexOf("fr") === 0) return v;
      if (want === "en" && lc.indexOf("en") === 0) return v;
      if (want === "es" && (lc.indexOf("es") === 0 || lc.indexOf("pt") === 0)) return v;
    }
    return voices.length ? voices[0] : null;
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    var i, text;

    if (role === "general"){
      text = collectGeneralText(root);
      if (text) units.push({ key:"general", text:text, detail:null });
      for (i=0;i<details.length;i++){
        text = collectDetailText(details[i]);
        if (text) units.push({ key:"detail:" + i, text:text, detail:details[i] });
      }
      return units;
    }

    for (i=Math.max(0, index); i<details.length; i++){
      text = collectDetailText(details[i]);
      if (text) units.push({ key:"detail:" + i, text:text, detail:details[i] });
    }
    return units;
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang || getLang());
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = btn.getAttribute("data-po-audio-role") || "detail";
      var index = parseInt(btn.getAttribute("data-po-audio-index"), 10);
      var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    }
  }

  function resetAudioState(){
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = getLang();
    PO_AUDIO_STATE.voice = null;
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    resetAudioState();
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], getLang());
  }

  function playCurrentChunk(){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.root) return;
    if (PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit();
      return;
    }

    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt){
      PO_AUDIO_STATE.chunkPos += 1;
      playCurrentChunk();
      return;
    }

    var utt = new SpeechSynthesisUtterance(txt);
    utt.lang = normLang(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utt.voice = PO_AUDIO_STATE.voice;
    utt.onend = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      playCurrentChunk();
    };
    utt.onerror = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      playCurrentChunk();
    };
    try{ PO_AUDIO_SYNTH.speak(utt); }catch(e){ stopAudio(); }
  }

  function playCurrentUnit(){
    if (!PO_AUDIO_STATE.root) return;
    if (PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit || !unit.text){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit();
      return;
    }

    PO_AUDIO_STATE.activeKey = unit.key;
    if (unit.detail && typeof unit.detail.open !== "undefined") unit.detail.open = true;
    PO_AUDIO_STATE.chunks = chunkText(unit.text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAudioLabels(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    playCurrentChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    playCurrentUnit();
  }

  function createAudioButton(role, index){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    if (role !== "general") btn.setAttribute("data-po-audio-index", String(index));
    btn.setAttribute("aria-pressed", "false");
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");
        generalWrap.appendChild(createAudioButton("general"));

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");

        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else{
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail", i);
        summary.appendChild(btn);
      }else{
        btn.setAttribute("data-po-audio-index", String(i));
      }
    }
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * FALLBACK trilingue
   * -------------------------------------------------------------------------- */

  var FALLBACK = {
    "fr": {
        "title": "Posœnnomia",
        "kicker": "Extrait – La Katûvýsissence",
        "h_def": "Définition opérative",
        "chips": [
            "Univers : Posœnnomia",
            "Idéogramme conceptuel",
            "Nombre-guide 21"
        ],
        "chip_urls": [
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennomia_2.png?v=1746291369",
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennomia_univerS_2.png?v=1746291388",
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_21.png?v=1770265018"
        ],
        "def_short": "Univers posœnnoïomial : champ traversant, opérateur d’ouverture et espace d’application expérimental où le système s’éprouve, se règle et se prolonge sans se refermer.",
        "def_long": "La Posœnnomia se comprend comme un dehors intérieur au système : elle ne s’ajoute pas, elle traverse. Sa fonction tient dans une grammaire simple et exigeante : rendre le Posœnnoïsme praticable au contact du monde sans refermer l’Organon sur ses propres réussites. Elle constitue un univers-lieu non fixé une fois pour toutes, capable d’apparaître sous forme d’atelier, de dispositif public, de scène pédagogique, de laboratoire numérique, de marche d’écoute, de protocole de décision lente ou d’architecture en pleine nature. Là, la structure se met en situation, s’ajuste et s’éprouve.\n\nÀ la différence de la Posœnnoïamie — univers relationnel inclus dans l’Organon — Posœnnomia n’est pas un dedans communautaire, mais une aire de traversée. Elle accueille ce qui excède : surplus de sens, tensions non résolues, essais méthodologiques, prolongements créatifs, retours d’usage. Elle sert de seuil actif entre ce qui se formalise et ce qui cherche encore sa forme. On y accueille les écarts pour les convertir en directions opératives, dans une topologie fluide qui laisse l’exposition redevenir recherche, la marche se changer en écriture et la base de données se muer en récit.\n\nSon lien avec la Katûvýsissence et la Katûvýs demeure décisif. La Katûvýsissence recueille et stratifie ; Posœnnomia expose, agence, confronte et relance. La Katûvýs porte la mémoire de fond ; Posœnnomia en éprouve la plasticité dans l’usage, avec l’aide de l’Ennéagone, d’Isqun, des Balakallpa, des Katûvýsqun et des interfaces Taxiêlîs, Tiqqunbahu, Ušôprogalenmestûd. Ainsi, Posœnnomia maintient l’Organon dans un état de respiration : une fenêtre structurelle qui s’ouvre sans faire s’effondrer la maison.",
        "h_features": "Modèle d’interaction avec les autres éléments",
        "h_questions": "Régime méthodologique minimal",
        "hint_fold": "déplier",
        "example_title": "Séquence d’essai (mémoire–usage–mémoire)",
        "example": "— Accueil : formuler l’enjeu et sa portée\n— Orientation : poser critères, hypothèses et seuils d’arrêt\n— Mise à l’essai : cadence, durée, outils et responsabilités\n— Observation : lire signaux, résistances et effets utiles\n— Redistribution : décider ce qui continue, cesse, migre\n— Dépôt : rendre trace à la Katûvýsissence et ouvrir pistes de reprise",
        "features": [
            "Katûvýs : matrice-substrat et source d’intensités ; Posœnnomia en éprouve la plasticité dans l’usage.",
            "Katûvýsissence : mémoire spiralée ; Posœnnomia expose les dépôts à l’épreuve des situations puis renvoie des traces transmutées vers le réservoir de relance.",
            "Ennéagone régulateur : équilibrage discret, absorption et redistribution des excès lorsque l’expérimentation produit surcharge ou débordement.",
            "Isqun / Threnisqun : interventions situées et brèves quand un blocage local exige une ponctuation de régulation.",
            "Balakallpa, Katûvýsqun et interfaces Taxiêlîs, Tiqqunbahu, Ušôprogalenmestûd : véhicules, vortex d’alignement et médiations techniques qui rendent la traversée opérable."
        ],
        "questions": [
            "Accueil : quel enjeu réel doit être formulé pour que l’essai reste lisible ?",
            "Orientation : quels critères et quels seuils d’arrêt protègent l’ouverture d’une dérive ?",
            "Mise à l’essai : quelle cadence, quelle durée, quels outils et quelles responsabilités ?",
            "Observation : quels signaux indiquent résistance, surcharge, effet utile ou bascule ?",
            "Redistribution : que faut-il poursuivre, suspendre, déplacer ou transmettre ?",
            "Dépôt : quelle trace rendre à la Katûvýsissence pour qu’elle redevienne ressource ?"
        ],
        "h_family": "Champ d’opération & fonctions structurantes",
        "family_1": "<p><strong>Où Posœnnomia apparaît :</strong> terrains d’atelier, espace public, dispositifs numériques <span translate=\"no\">MOCoN</span>, scènes pédagogiques et contextes civiques ; usages d’essais d’œuvres et de textes, rituels de seuil, parcours commentés, cliniques d’accords et enquêtes ; échelles micro, méso et macro, du geste au programme.</p>",
        "family_2": "<p><strong>Fonction structurante :</strong> donner au Posœnnoïsme son terrain d’épreuve, rendre translucide le passage entre pratiques et situations, porter une dimension rituelo-symbolique où la traversée se fait signe, l’acte se fait symbole et l’expérience devient partageable. Complémentarité stricte avec <span translate=\"no\">Posœnnoïamie</span> : maison et atelier d’un côté, horizon et passage de l’autre.</p>",
        "h_wordbuild": "Positionnements & nombre-guide 21",
        "word_blocks": [
            {
                "head": "Positionnement vis-à-vis d’autres modèles",
                "text": "Posœnnomia résonne avec la praxis des ateliers et des laboratoires, avec les traditions du seuil et avec la pensée des systèmes ouverts. La finalité s’y déplace : l’enjeu reste l’orientation, et la boucle mémoire–usage–mémoire maintient l’axe."
            },
            {
                "head": "Nombre-guide 21 — lecture opérative",
                "text": "21 agit comme chiffre de passage : il relie, met en circulation et ouvre route. Mis en regard du 33 de Posœnnoïamie, il marque une différence de fonction : là où 33 soutient, 21 fait courir ; là où 33 donne colonne, 21 ouvre chemin. Il évite autant la forteresse que la dérive et ramène la traversée à la question de la justesse."
            },
            {
                "head": "Clôture synthétique",
                "text": "Univers de traversée : champ d’essais et de situations où le Posœnnoïsme éprouve sa plasticité sans perdre axe. Posœnnomia relie Katûvýs, Katûvýsissence, Ennéagone, Isqun et médiations techniques ; elle refuse clôture, dogme et fin par exigence d’ouverture méthodique. L’Humanus y apprend que l’ouverture devient discipline."
            }
        ],
        "word_notes": [
            "Principe : dehors intérieur — traverser au lieu d’ajouter.",
            "But : rendre le système praticable au contact du monde sans refermer l’Organon sur lui-même.",
            "Méthode : protection contre improvisation sans mémoire et codification sans vie."
        ]
    },
    "en": {
        "title": "Posœnnomia",
        "kicker": "Excerpt — The Katûvýsissence",
        "h_def": "Operative definition",
        "chips": [
            "Universe: Posœnnomia",
            "Concept ideogram",
            "Guide number 21"
        ],
        "chip_urls": [
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennomia_2.png?v=1746291369",
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennomia_univerS_2.png?v=1746291388",
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_21.png?v=1770265018"
        ],
        "def_short": "A posœnnoïomial universe: a traversing field, an openness operator and an experimental space of application where the system is tested, adjusted and prolonged without closing upon itself.",
        "def_long": "Posœnnomia can be understood as an inner outside of the system: it does not add, it traverses. Its function is simple and demanding: make Posœnnoïsme workable in contact with the world without closing the Organon upon its own successes. It forms a universe-place never fixed once and for all, able to appear as a studio, a public device, a pedagogical scene, a digital laboratory, a listening walk, a slow-decision protocol or an architecture in nature. There, structure is put into situation, adjusted and tested.\n\nUnlike Posœnnoïamie — the relational universe included in the Organon — Posœnnomia is not a communal inside but an area of crossing. It hosts what exceeds: surplus of meaning, unresolved tensions, methodological trials, creative prolongations and feedback from use. It acts as an active threshold between what is formalized and what is still searching for form. In this fluid topology, exhibition may become research again, a walk may turn into writing and a database may become narrative.\n\nIts relation to Katûvýsissence and Katûvýs is decisive. Katûvýsissence gathers and stratifies; Posœnnomia exposes, arranges, confronts and relaunches. Katûvýs carries background memory; Posœnnomia tests its plasticity in use, with the help of the Ennéagone, Isqun, Balakallpa, Katûvýsqun and the interfaces Taxiêlîs, Tiqqunbahu and Ušôprogalenmestûd. In this way, Posœnnomia keeps the Organon breathing: a structural window that opens without making the house collapse.",
        "h_features": "Interaction model with other elements",
        "h_questions": "Minimal methodological regime",
        "hint_fold": "expand",
        "example_title": "Trial sequence (memory–use–memory)",
        "example": "— Welcome: state the stake and its scope\n— Orientation: set criteria, hypotheses and stopping thresholds\n— Trial: cadence, duration, tools and responsibilities\n— Observation: read signals, resistances and useful effects\n— Redistribution: decide what continues, stops or migrates\n— Deposit: return traces to Katûvýsissence and open paths for relaunch",
        "features": [
            "Katûvýs: matrix-substrate and source of intensities; Posœnnomia tests its plasticity in use.",
            "Katûvýsissence: spiral memory; Posœnnomia exposes deposits to situations, then returns transmuted traces to the relaunch reservoir.",
            "Regulating Ennéagone: discreet balancing, absorption and redistribution of excess when experimentation overloads.",
            "Isqun / Threnisqun: situated and brief interventions when a local blockage requires regulating punctuation.",
            "Balakallpa, Katûvýsqun and the interfaces Taxiêlîs, Tiqqunbahu, Ušôprogalenmestûd: vehicles, alignment vortices and technical mediations that make crossing operable."
        ],
        "questions": [
            "Welcome: what real stake must be stated so the trial remains readable?",
            "Orientation: what criteria and stopping thresholds protect openness from drift?",
            "Trial: what cadence, duration, tools and responsibilities?",
            "Observation: which signals indicate resistance, overload, useful effect or shift?",
            "Redistribution: what should continue, pause, move or be transmitted?",
            "Deposit: what trace must be returned to Katûvýsissence so it becomes a resource again?"
        ],
        "h_family": "Operational field & structuring functions",
        "family_1": "<p><strong>Where Posœnnomia appears:</strong> studio terrains, public space, digital devices <span translate=\"no\">MOCoN</span>, pedagogical scenes and civic contexts; trials of works and texts, threshold rituals, guided walks, accord clinics and inquiries; micro, meso and macro scales, from gesture to program.</p>",
        "family_2": "<p><strong>Structuring function:</strong> give Posœnnoïsme its proving ground, make the passage between practices and situations translucent, and hold a ritual-symbolic dimension where crossing becomes sign, act becomes symbol and experience becomes shareable. Strict complementarity with <span translate=\"no\">Posœnnoïamie</span>: house and studio on one side, horizon and passage on the other.</p>",
        "h_wordbuild": "Positions & guide number 21",
        "word_blocks": [
            {
                "head": "Positioning vis-à-vis other models",
                "text": "Posœnnomia resonates with workshop and laboratory praxis, with threshold traditions and with open-systems thinking. Finality shifts here: orientation remains the stake, and the memory–use–memory loop keeps the axis."
            },
            {
                "head": "Guide number 21 — operative reading",
                "text": "21 acts as a passage number: it links, circulates and opens a route. Set against Posœnnoïamie’s 33, it marks a difference of function: where 33 supports, 21 runs; where 33 gives a column, 21 opens a path. It prevents both fortress and drift and returns crossing to the question of justness."
            },
            {
                "head": "Synthetic closure",
                "text": "A universe of crossing: a field of trials and situations where Posœnnoïsme tests its plasticity without losing axis. Posœnnomia links Katûvýs, Katûvýsissence, Ennéagone, Isqun and technical mediations; it refuses closure, dogma and ending through a demand for methodical openness. Here Humanus learns that openness becomes discipline."
            }
        ],
        "word_notes": [
            "Principle: inner outside — traverse rather than add.",
            "Aim: make the system workable in contact with the world without closing the Organon upon itself.",
            "Method: protection against improvisation without memory and codification without life."
        ]
    },
    "es": {
        "title": "Posœnnomia",
        "kicker": "Extracto — La Katûvýsissence",
        "h_def": "Definición operativa",
        "chips": [
            "Universo: Posœnnomia",
            "Ideograma conceptual",
            "Número-guía 21"
        ],
        "chip_urls": [
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennomia_2.png?v=1746291369",
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennomia_univerS_2.png?v=1746291388",
            "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_21.png?v=1770265018"
        ],
        "def_short": "Universo posœnnoïomial: campo transversal, operador de apertura y espacio experimental de aplicación donde el sistema se pone a prueba, se ajusta y se prolonga sin clausurarse.",
        "def_long": "Posœnnomia se entiende como un afuera interior del sistema: no se añade, atraviesa. Su función es simple y exigente: volver practicable el Posœnnoïsme en contacto con el mundo sin cerrar el Organon sobre sus propios logros. Constituye un universo-lugar no fijado de una vez, capaz de aparecer como taller, dispositivo público, escena pedagógica, laboratorio digital, caminata de escucha, protocolo de decisión lenta o arquitectura en la naturaleza. Allí, la estructura se pone en situación, se ajusta y se prueba.\n\nA diferencia de Posœnnoïamie — universo relacional incluido en el Organon — Posœnnomia no es un adentro comunitario sino un área de travesía. Acoge lo que excede: excedentes de sentido, tensiones no resueltas, ensayos metodológicos, prolongaciones creativas y retornos de uso. Actúa como umbral activo entre lo que se formaliza y lo que aún busca forma. En esta topología fluida, la exposición puede volver a ser investigación, la caminata puede convertirse en escritura y la base de datos puede mutar en relato.\n\nSu relación con Katûvýsissence y Katûvýs es decisiva. Katûvýsissence recoge y estratifica; Posœnnomia expone, organiza, confronta y relanza. Katûvýs lleva la memoria de fondo; Posœnnomia prueba su plasticidad en el uso, con ayuda del Ennéagone, Isqun, Balakallpa, Katûvýsqun y las interfaces Taxiêlîs, Tiqqunbahu y Ušôprogalenmestûd. Así, Posœnnomia mantiene al Organon respirando: una ventana estructural que se abre sin hacer colapsar la casa.",
        "h_features": "Modelo de interacción con otros elementos",
        "h_questions": "Régimen metodológico mínimo",
        "hint_fold": "desplegar",
        "example_title": "Secuencia de ensayo (memoria–uso–memoria)",
        "example": "— Acogida: formular el desafío y su alcance\n— Orientación: fijar criterios, hipótesis y umbrales de parada\n— Puesta a prueba: cadencia, duración, herramientas y responsabilidades\n— Observación: leer señales, resistencias y efectos útiles\n— Redistribución: decidir lo que continúa, cesa o migra\n— Depósito: devolver huellas a Katûvýsissence y abrir pistas de relanzamiento",
        "features": [
            "Katûvýs: matriz-sustrato y fuente de intensidades; Posœnnomia prueba su plasticidad en el uso.",
            "Katûvýsissence: memoria espiral; Posœnnomia expone depósitos a las situaciones y devuelve huellas transmutadas al reservorio de relanzamiento.",
            "Ennéagone regulador: equilibrio discreto, absorción y redistribución de excesos cuando la experimentación produce sobrecarga.",
            "Isqun / Threnisqun: intervenciones situadas y breves cuando un bloqueo local exige una puntuación reguladora.",
            "Balakallpa, Katûvýsqun y las interfaces Taxiêlîs, Tiqqunbahu, Ušôprogalenmestûd: vehículos, vórtices de alineación y mediaciones técnicas que vuelven operable la travesía."
        ],
        "questions": [
            "Acogida: ¿qué desafío real debe formularse para que el ensayo siga siendo legible?",
            "Orientación: ¿qué criterios y umbrales de parada protegen la apertura frente a la deriva?",
            "Puesta a prueba: ¿qué cadencia, duración, herramientas y responsabilidades?",
            "Observación: ¿qué señales indican resistencia, sobrecarga, efecto útil o basculación?",
            "Redistribución: ¿qué debe continuar, suspenderse, desplazarse o transmitirse?",
            "Depósito: ¿qué huella devolver a Katûvýsissence para que vuelva a ser recurso?"
        ],
        "h_family": "Campo de operación y funciones estructurantes",
        "family_1": "<p><strong>Dónde aparece Posœnnomia:</strong> terrenos de taller, espacio público, dispositivos digitales <span translate=\"no\">MOCoN</span>, escenas pedagógicas y contextos cívicos; ensayos de obras y textos, rituales de umbral, recorridos comentados, clínicas de acuerdos e investigaciones; escalas micro, meso y macro, del gesto al programa.</p>",
        "family_2": "<p><strong>Función estructurante:</strong> ofrecer al Posœnnoïsme su terreno de prueba, hacer translúcido el paso entre prácticas y situaciones, y sostener una dimensión ritual-simbólica donde la travesía se vuelve signo, el acto se vuelve símbolo y la experiencia se vuelve compartible. Complementariedad estricta con <span translate=\"no\">Posœnnoïamie</span>: casa y taller por un lado, horizonte y paso por el otro.</p>",
        "h_wordbuild": "Posicionamientos y número-guía 21",
        "word_blocks": [
            {
                "head": "Posicionamiento frente a otros modelos",
                "text": "Posœnnomia entra en resonancia con la praxis de talleres y laboratorios, con las tradiciones del umbral y con el pensamiento de sistemas abiertos. La finalidad se desplaza aquí: la orientación sigue siendo el reto, y el bucle memoria–uso–memoria mantiene el eje."
            },
            {
                "head": "Número-guía 21 — lectura operativa",
                "text": "21 actúa como cifra de paso: enlaza, pone en circulación y abre ruta. En contraste con el 33 de Posœnnoïamie, marca una diferencia de función: donde 33 sostiene, 21 corre; donde 33 da columna, 21 abre camino. Evita tanto la fortaleza como la deriva y devuelve la travesía a la cuestión de la justeza."
            },
            {
                "head": "Cierre sintético",
                "text": "Universo de travesía: campo de ensayos y situaciones donde el Posœnnoïsme prueba su plasticidad sin perder eje. Posœnnomia enlaza Katûvýs, Katûvýsissence, Ennéagone, Isqun y mediaciones técnicas; rehúsa clausura, dogma y final por exigencia de apertura metódica. Aquí el Humanus aprende que la apertura se vuelve disciplina."
            }
        ],
        "word_notes": [
            "Principio: afuera interior — atravesar en lugar de añadir.",
            "Objetivo: volver practicable el sistema en contacto con el mundo sin cerrar el Organon sobre sí mismo.",
            "Método: protección contra improvisación sin memoria y codificación sin vida."
        ]
    }
};
  /* --------------------------------------------------------------------------
   * DATA merge
   * -------------------------------------------------------------------------- */

  function getAxisLexId(node){
    try{ return node.getAttribute("data-po-lex-id") || ""; }
    catch(e){ return ""; }
  }

  function getAxisData(lang, node){
    var lexId = getAxisLexId(node);
    var base = FALLBACK[lang] || FALLBACK.fr;
    if (lexId && lexId !== "posoennomia") return null;
    if (!lexId) return base;

    var entry = getLexiconEntry(lexId);
    if (!entry) return base;

    var out = {};
    for (var k in base) out[k] = base[k];
    out.title = CANON.title;

    var ds = pickDefShort(entry, lang);
    if (ds) out.def_short = ds;

    var dl = pickDefLong(entry, lang);
    if (dl) out.def_long = dl;

    var q = pickArraySmart(entry, lang, ["usage_questions", "tests_usage"]);
    if (q && q.length) out.questions = q;

    var f = pickArray(entry, lang, "features");
    if (f && f.length) out.features = f;

    return out;
  }

  function bindLangButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll("[data-po-lang-btn]");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poLangBound) continue;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var lang = this.getAttribute("data-po-lang-btn") || "fr";
        applyLangEverywhere(lang);
      });
      btn.__poLangBound = true;
    }
  }

  function setPressed(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll("[data-po-lang-btn]");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var isOn = (btn.getAttribute("data-po-lang-btn") === lang);
      btn.setAttribute("aria-pressed", isOn ? "true" : "false");
      if (isOn) btn.classList.add("is-active");
      else btn.classList.remove("is-active");
    }
  }

  function applyToAxis(node, lang){
    var data = getAxisData(lang, node);
    if (!data) return;

    setSlotText(node, "title", data.title);
    setSlotText(node, "kicker", data.kicker);
    setSlotText(node, "h_def", data.h_def);

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, "chip_1", chips[0] || "");
    setSlotText(node, "chip_2", chips[1] || "");
    setSlotText(node, "chip_3", chips[2] || "");

    var chipUrls = Array.isArray(data.chip_urls) ? data.chip_urls : [];
    var urlUnivers = chipUrls[0] || "";
    var urlIdeogramme = chipUrls[1] || "";
    var url33 = chipUrls[2] || "";

    setSlotImgSrc(node, "chip_1_img", urlIdeogramme, chips[0] || "");
    setSlotImgSrc(node, "chip_2_img", urlUnivers, chips[1] || "");
    setSlotImgSrc(node, "chip_3_img", url33, chips[2] || "");
    setSlotImgSrc(node, "title_img", urlUnivers, data.title || "");

    setSlotHTML(node, "def_short", htmlParagraphize(data.def_short));
    setSlotHTML(node, "def_long", htmlParagraphize(data.def_long));

    setSlotText(node, "h_features", data.h_features);
    setSlotText(node, "hint_fold", data.hint_fold);
    renderList(node, "features", data.features);

    setSlotText(node, "h_questions", data.h_questions);
    setSlotText(node, "hint_fold2", data.hint_fold);
    renderList(node, "questions", data.questions);
    renderExampleBox(node, "example_box", data.example_title, data.example);

    setSlotText(node, "h_family", data.h_family);
    setSlotText(node, "hint_fold3", data.hint_fold);
    setSlotHTML(node, "family_1", data.family_1);
    setSlotHTML(node, "family_2", data.family_2);

    setSlotText(node, "h_wordbuild", data.h_wordbuild);
    renderWordBlocks(node, "wordbuild_blocks", data.word_blocks);
    renderList(node, "wordbuild_notes", data.word_notes);

    lockSlotNode(node, "title");
    protectSlotTextIfNeeded(node, "kicker");
    protectSlotTextIfNeeded(node, "chip_1");
    protectSlotTextIfNeeded(node, "chip_2");
    protectSlotTextIfNeeded(node, "chip_3");
  }

  function applyLangEverywhere(lang){
    lang = storeLang(lang || getLang());
    var blocks = getTargetBlocks();
    for (var i=0;i<blocks.length;i++){
      bindLangButtons(blocks[i]);
      setPressed(blocks[i], lang);
      applyToAxis(blocks[i], lang);
    }
    initAudioEverywhere(lang);
    notifyLocaleChanged();
    return lang;
  }

  function lexiconLooksReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
    }catch(e){}
    return false;
  }

  function init(){
    applyLangEverywhere(getLang());

    window.addEventListener("po:lexicon-ready", function(){
      __PO_PROTECT_CACHE__.key = "";
      __PO_PROTECT_CACHE__.re = null;
      applyLangEverywhere(getLang());
    });

    try{
      var mo = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          if (muts[i].type === "attributes" && muts[i].attributeName === "lang"){
            if (!readStoredLang()) applyLangEverywhere(getLang());
            break;
          }
        }
      });
      if (document && document.documentElement){
        mo.observe(document.documentElement, { attributes:true });
      }
    }catch(e){}

    if (!lexiconLooksReady()){
      var tries = 0;
      var maxTries = 80;
      var timer = setInterval(function(){
        tries++;
        if (lexiconLooksReady() || tries >= maxTries){
          clearInterval(timer);
          __PO_PROTECT_CACHE__.key = "";
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 100);
    }
  }

  window.PoAxisPosoennomiaTextsFR_EN_ES_20260202 = {
    init: init,
    getLang: getLang,
    setLang: applyLangEverywhere,
    normLang: normLang,
    stopAudio: stopAudio
  };

  try{
    if (!window.GoodyTwinLang){
      window.GoodyTwinLang = { init:init, getLang:getLang, setLang:applyLangEverywhere };
    }else{
      if (typeof window.GoodyTwinLang.getLang !== "function") window.GoodyTwinLang.getLang = getLang;
      if (typeof window.GoodyTwinLang.setLang !== "function") window.GoodyTwinLang.setLang = applyLangEverywhere;
      if (typeof window.GoodyTwinLang.init !== "function") window.GoodyTwinLang.init = init;
    }
  }catch(e){}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
